import { Routes } from '@angular/router'

export const routes: Routes = [
  {
    path: 'healthz',
    loadChildren: () =>
      import('../../libs/drrweb-lib/src/lib/modules/health/health.routes').then(
        (m) => m.HEALTH_ROUTES
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import(
        '../../libs/drrweb-lib/src/lib/bootstrap/drrweb-main.routes'
      ).then((m) => m.DRR_WEB_MAIN_ROUTES),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
]
